var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articles",attrs:{"id":"articles"}},[_c('div',{staticClass:"articles-container"},[_c('h2',{staticClass:"articles-title"},[_vm._v("Что о нас пишут")]),_c('div',{staticClass:"articles-list"},[_c('ArticleSlider',{attrs:{"slides":_vm.articlesList}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }